import OrderTrackerPage from './OrderTrackerPage';

export default {
  OrderTrackerPage,
};
